import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GraphqlUtil {
  static getAuthMode(isPublicPage: boolean): 'apiKey' | 'userPool' {
    return isPublicPage ? 'apiKey' : 'userPool';
  }
}
